export default __webpack_public_path__ + "1ec6a677c23635c1bafd32f893853366.png";